import axios from '@/plugins/axios'

export function getInviteNewUsersConfigs(params = {}) {
  return axios.get('invite_new_users_configs', {
    params,
  })
}

export function editInviteNewUsersConfigs(id) {
  return axios.get(`invite_new_users_configs/${id}/edit`)
}

export function storeInviteNewUsersConfigs(data) {
  return axios.post('invite_new_users_configs', data)
}

export function updateInviteNewUsersConfigs(id, data) {
  return axios.put(`invite_new_users_configs/${id}`, data)
}

export function getInviteNewUsers(params = {}) {
  return axios.get('invite_new_users', {
    params,
  })
}
export function getInviteNewUsersGiveGiftLog(params = {}) {
  return axios.get('invite_new_users_give_gift_log', {
    params,
  })
}
